module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeftLight--dark-40febeb82a2888cfd630808103a3d3ca.png";